const inFlightRequests = new Map();
const responseCache = new Map();

const now = () => Date.now();

export const getCachedResponse = (key) => {
  const entry = responseCache.get(key);
  if (!entry) return null;
  if (entry.expiresAt <= now()) {
    responseCache.delete(key);
    return null;
  }
  return entry.value;
};

export const setCachedResponse = (key, value, ttlMs) => {
  if (!ttlMs || ttlMs <= 0) return;
  responseCache.set(key, { value, expiresAt: now() + ttlMs });
};

export const withRequestCache = async ({ key, ttlMs = 0, requestFn }) => {
  const cached = getCachedResponse(key);
  if (cached) return cached;

  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }

  const pending = Promise.resolve()
    .then(requestFn)
    .then((value) => {
      setCachedResponse(key, value, ttlMs);
      return value;
    })
    .finally(() => {
      inFlightRequests.delete(key);
    });

  inFlightRequests.set(key, pending);
  return pending;
};

export const clearRequestCacheByPrefix = (prefix) => {
  Array.from(responseCache.keys()).forEach((key) => {
    if (key.startsWith(prefix)) responseCache.delete(key);
  });
};

